import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Tooltip from '../../elements/messages/Tooltip';
import ReactTooltip from 'react-tooltip';

class SidebarProducts extends React.Component {
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  render() {
    const { items, t, mobile, header, isOpen } = this.props;
    const headerUrl = header.length > 0 ? header[0].url : '';
    if (!items) return null;

    return (
      <ul className="sidebar-nav">
        {!isOpen && <Tooltip id="sidebarTip" place="right" />}
        {items.map(it => {
          const selected = it.url.includes(window.location.hostname);
          const trans = `Navigator.DisplayText.${it.id}`;
          const txt = t(trans) || t(it.label) || it.label;
          let el = (
            <a
              href={it.url}
              className={selected ? 'nav-link selected' : 'nav-link'}
              data-for="sidebarTip"
              data-tip={txt}
            >
              <i className={`icon icon-${it.icon}`} />
              <span className="label">{txt}</span>
            </a>
          );
          if (it.url.startsWith('/')) {
            el = (
              <NavLink
                className="nav-link"
                to={it.url}
                isActive={() => it.url.includes(window.location.hostname)}
                activeClassName="selected"
                data-for="sidebarTip"
                data-tip={txt}
              >
                <i className={`icon icon-${it.icon}`} />
                <span className="label">{txt}</span>
              </NavLink>
            );
          }
          return (
            <li key={'navitem' + it.url} className="nav-item">
              {el}
              {mobile &&
                headerUrl.includes(it.url) && (
                  <ul className="level-2">
                    {header.map((h, i) => {
                      return (
                        <li key={'nav-sub-item' + h.url} className="nav-item">
                          <NavLink
                            exact={i === 0}
                            className="nav-link"
                            to={h.url}
                            activeClassName="selected"
                          >
                            <span className="label">{t(h.text)}</span>
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                )}
            </li>
          );
        })}
      </ul>
    );
  }
}

SidebarProducts.propTypes = {
  items: PropTypes.array
};

export default SidebarProducts;



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Sidebar/SidebarProducts.js